//#region Imports
import { AuthenticationService } from '@app/member-response-portal/service/authentication.service';
import { DialogService } from './dialog-service.service';
import { TIMER_OPTIONS } from '@app/member-response-portal/model/constants';
import { Injectable  } from '@angular/core';
import { SessionLogoutDialogComponent } from '@app/member-response-portal/shared/components/session-logout-dialog/session-logout-dialog.component';
import { SessionTimeoutDialogComponent } from '@app/member-response-portal/shared/components/session-timeout-dialog/session-timeout-dialog.component';
//#endregion Imports
@Injectable({
  providedIn: 'root',
})
export class InactivityTimerService {
    //#region Private Variables
    private InactivityTimer: any;
    private InactivityTimerOptions: number[] = [TIMER_OPTIONS.MINUTES_10, TIMER_OPTIONS.MINUTES_5, TIMER_OPTIONS.MINUTES_1];
    private AttemptIndex: number = 0;
    private CurrentCountDownTime: number = this.InactivityTimerOptions[this.AttemptIndex];
    //#endregion Private Variables

    //#region Properties
    private get HasAvailableAttempts(): boolean {
        return this.AttemptIndex < this.InactivityTimerOptions.length - 1;
    }
    //#endregion Properties

    constructor(
        private authenticationService: AuthenticationService,
        private dialogService: DialogService
    ){}

    //#region Public Methods
    public StartInactivityTimer(): void {
        if(this.InactivityTimer){
            this.ClearInactivityTimer()
        }

        this.CurrentCountDownTime = this.InactivityTimerOptions[this.AttemptIndex];

        this.InactivityTimer = setInterval(() => {
            this.CurrentCountDownTime--;

            if (this.CurrentCountDownTime <= 0) {
                if(this.HasAvailableAttempts){
                    this.ShowInactivityCountDownDialog();
                }else{
                    this.ShowInactivityLogOutDialog();
                }
            }
        }, 1000);
    }

    public ResetTimerOnActivity(): void {
        if (this.AttemptIndex === 0 && this.InactivityTimer) {
            this.StartInactivityTimer();
        }
    }

    public ShowInactivityCountDownDialog(): void {
        this.ClearInactivityTimer();
        this.dialogService.OpenDialog(SessionTimeoutDialogComponent);
    }

    public ShowInactivityLogOutDialog(): void {
        this.StopInactivityTimerService();
        this.authenticationService.Logout();
        this.dialogService.OpenDialog(SessionLogoutDialogComponent);
    }

    public ContinueSession(): void {
        this.AttemptIndex++;
        this.StartInactivityTimer();
    }

    public LogoutAndRedirectToLogin(): void {
        this.StopInactivityTimerService();
        this.authenticationService.LogoutAndRedirectToLogin();
    }

    public StopInactivityTimerService(): void {
        this.ResetAttempts();
        this.ClearInactivityTimer();
    }
    //#endregion Public Methods

    //#region Private Methods
    private ClearInactivityTimer(): void {
        clearInterval(this.InactivityTimer);
        this.InactivityTimer = null;
        this.ResetTimer();
    }

    private ResetAttempts(): void {
        this.AttemptIndex = 0;
    }

    private ResetTimer(): void {
        this.CurrentCountDownTime = this.InactivityTimerOptions[this.AttemptIndex];
    }
    //#endregion Private Methods
}
